import { FC, useRef, useState } from "react"
import { ChallengeSectionProps } from "../../pages/Challenge"
import CodeEditor from "../CodeEditor"
import Button from "../Button"
import classNames from "classnames"
import useError from "../../hooks/useError"
import { ChallengesService } from "../../sdk"
import { toast } from "react-toastify"
import HtmlRenderModal from "../HtmlRenderModal"

const ChallengeDescriptionEditor: FC<ChallengeSectionProps> = ({ challenge: { htmlDescription, id: challengeId } }) => {
  const initialCode = useRef<string>(htmlDescription)
  const [code, setCode] = useState<string>(htmlDescription)
  const [loading, setLoading] = useState<boolean>(false)
  const [previewHtmlModalOpen, setPreviewHtmlModalOpen] = useState<boolean>(false)

  const { handleError } = useError()

  const onSubmit = async(): Promise<void> => {
    setLoading(true)
    try {
      await ChallengesService.updateChallenge({
        handler: { challengeId },
        updates: {
          htmlDescription: code
        }
      })

      initialCode.current = code
      toast.success("Descrizione HTML aggiorna correttamente!")
    } catch (err) {
      handleError(err)
    }
    setLoading(false)
  }

  return (
    <>
      <h2 className="mb-4 text-2xl font-semibold">Descrizione HTML</h2>

      <div className={classNames(loading && "opacity-50 pointer-events-none")}>
        <CodeEditor
          code={code}
          language="html"
          onValueChange={setCode}
        />

        <div className="flex justify-end items-center gap-4 mt-4">
          <Button onClick={(): void => setPreviewHtmlModalOpen(true)}>
            Anteprima
          </Button>

          <Button disabled={initialCode.current === code} onClick={onSubmit}>
            Salva
          </Button>
        </div>
      </div>
      {previewHtmlModalOpen &&
        <HtmlRenderModal
          html={code}
          close={(): void => setPreviewHtmlModalOpen(false)}
          title="Anteprima html"
        />
      }
    </>
  )
}

export default ChallengeDescriptionEditor
